import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../../axiosInstance';

const Vendors = () => {
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingVendor, setEditingVendor] = useState(null); // For editing
    const [searchQuery, setSearchQuery] = useState(''); // Track search query
    const [form] = Form.useForm();

    // Fetch vendors whenever the search query changes
    useEffect(() => {
        fetchVendors();
    }, [searchQuery]);

    const fetchVendors = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/vendors', {
                params: { search: searchQuery },
            });
            setVendors(response.data.vendors || []);
        } catch (error) {
            message.error('Failed to load vendors.');
        } finally {
            setLoading(false);
        }
    };

    const handleAddOrUpdateVendor = async () => {
        try {
            const values = await form.validateFields();
            if (editingVendor) {
                // Update existing vendor
                await axiosInstance.put(`/vendors/${editingVendor.id}`, values);
                setVendors(vendors.map(v => (v.id === editingVendor.id ? { ...v, ...values } : v)));
                message.success('Vendor updated successfully!');
            } else {
                // Add new vendor
                const response = await axiosInstance.post('/vendors', values);
                setVendors([...vendors, response.data.vendor]);
                message.success('Vendor added successfully!');
            }
            setIsModalVisible(false);
            form.resetFields();
            setEditingVendor(null);
        } catch (error) {
            message.error('Failed to save vendor.');
        }
    };

    const handleEdit = (vendor) => {
        setEditingVendor(vendor);
        form.setFieldsValue(vendor);
        setIsModalVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            await axiosInstance.delete(`/vendors/${id}`);
            setVendors(vendors.filter(vendor => vendor.id !== id));
            message.success('Vendor deleted successfully!');
        } catch (error) {
            message.error('Failed to delete vendor.');
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <Input
                    placeholder="Search vendors..."
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ width: 300 }}
                />
                <Button type="primary" onClick={() => setIsModalVisible(true)}>
                    Add Vendor
                </Button>
            </div>
            <Table
                dataSource={vendors.map(vendor => ({ key: vendor.id, ...vendor }))}
                columns={[
                    { title: 'Name', dataIndex: 'name', key: 'name' },
                    { title: 'Email', dataIndex: 'email', key: 'email' },
                    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
                    { title: 'Company', dataIndex: 'company', key: 'company' },
                    {
                        title: 'Action',
                        key: 'action',
                        render: (_, record) => (
                            <>
                                <Button
                                    style={{ marginRight: 8 }}
                                    onClick={() => handleEdit(record)}
                                >
                                    Edit
                                </Button>
                                {/* <Button danger onClick={() => handleDelete(record.key)}>
                                    Delete
                                </Button> */}
                            </>
                        ),
                    },
                ]}
                loading={loading}
                pagination={{ pageSize: 25 }}
                scroll={{ x: 'max-content' }}
            />
            <Modal
                title={editingVendor ? "Edit Vendor" : "Add Vendor"}
                visible={isModalVisible}
                onOk={form.submit}
                onCancel={() => {
                    setIsModalVisible(false);
                    setEditingVendor(null);
                    form.resetFields();
                }}
                okText={editingVendor ? "Update" : "Add"}
                cancelText="Cancel"
            >
                <Form form={form} layout="vertical" onFinish={handleAddOrUpdateVendor}>
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please input the vendor name!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ type: 'email', message: 'Please input a valid email!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[{ required: true, message: 'Please input a valid phone number!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="company" label="Company">
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Vendors;
